// extracted by mini-css-extract-plugin
export default {"flex":"ingredient_flex__jwu-O","ingredient":"ingredient_ingredient__1ou5G","counter":"ingredient_counter__HtC3A"};